export default __webpack_public_path__ + "static/media/closet2-1440w.0c80a59b.avif";